import mutations, { SideBarState } from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  namespaced: true,
  state: {} as SideBarState,
  actions,
  getters,
  mutations,
};
